module.exports = __webpack_public_path__ + "img/gif_pumper.edf8dd54.gif";